export default "__VITE_ASSET__ZxPiI_5G__"